import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button } from "reactstrap";
import { AgGridReact } from "ag-grid-react";
import Swal from "sweetalert2";
import { AiTwotoneEdit, AiFillDelete } from "react-icons/ai";

import requests from "../../../../utils/Requests";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

const ApiAgentMarkupTable = ({ onEdit, refreshKey, onRefresh }) => {
  const [rowData, setRowData] = useState([]);
  const apiLabels = {
    1: "Burj Khalifa",
    2: "Museum Of The Future",
  };

  useEffect(() => {
    getAgentMarkupList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshKey]);

  const getAgentMarkupList = () => {
    axios
      .post(requests.getApiAgentMarkupList, { apiId: 0, agentId: 0 })
      .then((response) => {
        const data = Array.isArray(response.data) ? response.data : [];
        setRowData(
          data.map((item) => ({
            ...item,
            apiLabel: apiLabels[item.apiId] || `API ${item.apiId}`,
          }))
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleDelete = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(requests.removeApiAgentMarkup, {
            apiAgentMarkupId: row.apiAgentMarkupId,
          })
          .then((res) => {
            if (res.data.errCode === 0) {
              Swal.fire({
                title: "Deleted!",
                text: "Record removed successfully.",
                icon: "success",
              });
              if (onRefresh) {
                onRefresh();
              } else {
                getAgentMarkupList();
              }
            } else {
              Swal.fire({
                title: "Warning!",
                text:
                  res.data.errMessage ||
                  "Unable to delete the selected record.",
                icon: "warning",
              });
            }
          })
          .catch((error) => {
            console.log(error);
            Swal.fire({
              title: "Error!",
              text: "Unable to delete the selected record.",
              icon: "error",
            });
          });
      }
    });
  };

  const columnDefs = [
    { headerName: "API", field: "apiLabel" },
    { headerName: "Agent", field: "agencyName" },
    { headerName: "Attraction Group", field: "attractionGroupName" },
    { headerName: "Attraction", field: "attractionName" },
    { headerName: "Ticket Type", field: "ticketTypeName" },
    { headerName: "Prime Adult Price", field: "primeAdultPrice" },
    { headerName: "Non Prime Adult Price", field: "nonPrimeAdultPrice" },
    { headerName: "Prime Child Price", field: "primeChildPrice" },
    { headerName: "Non Prime Child Price", field: "nonPrimeChilPrice" },
    {
      headerName: "Action",
      filter: false,
      sortable: false,
      cellRendererFramework: (params) => (
        <div>
          <Button
            color="primary"
            size="sm"
            onClick={() => onEdit && onEdit(params.data)}
            className="mr-2"
          >
            <AiTwotoneEdit />
          </Button>
          <Button
            color="danger"
            size="sm"
            onClick={() => handleDelete(params.data)}
          >
            <AiFillDelete />
          </Button>
        </div>
      ),
    },
  ];

  const defaultColDef = {
    sortable: true,
    flex: 1,
    filter: true,
    floatingFilter: true,
    resizable: true,
  };

  return (
    <div className="ag-theme-alpine" style={{ height: "500px" }}>
      <AgGridReact
        columnDefs={columnDefs}
        rowData={rowData}
        defaultColDef={defaultColDef}
        pagination
      />
    </div>
  );
};

export default ApiAgentMarkupTable;

